import {
  PaymentMethodsButtons,
  PaymentMethodsEnum,
} from "@zenith/features/Payments/types";

export function usePaymentIcon(paymentMethod?: PaymentMethodsEnum) {
  if (paymentMethod === undefined) return null;
  return PaymentMethodsButtons.find((b) => b.index === paymentMethod);
}
